import { Button, Form, Modal, Space, message } from "antd";
import { useState } from "react";
import { transportApi } from "../../api/transportApi";
import { getApiErrorMessage } from "../../utils/apiError";
import type { LookupItem } from "./LookupModal";
import { PartyCompositeFormFields } from "../../modules/parties/PartyCompositeFormFields";

interface PartyCreateModalProps {
  open: boolean;
  prefillName?: string;
  onClose: () => void;
  onCreated: (item: LookupItem) => void;
}

export const PartyCreateModal = ({
  open,
  prefillName,
  onClose,
  onCreated,
}: PartyCreateModalProps) => {
  const [form] = Form.useForm();
  const [saving, setSaving] = useState(false);

  const handleAfterOpen = (visible: boolean) => {
    if (visible) {
      form.resetFields();
      form.setFieldsValue({ type: "Customer", identityType: "GST", registrationType: "Unregistered", country: "India", openingBalanceType: "Dr", bankAccounts: [] });
      if (prefillName) form.setFieldValue("name", prefillName);
    }
  };

  const handleSave = async () => {
    let values: any;
    try { values = await form.validateFields(); }
    catch { return; }

    setSaving(true);
    try {
      const created = await transportApi.createPartyFull({ ...values, bankAccounts: (values.bankAccounts ?? []).filter((bank: any) => bank.bankName || bank.accountNumber) });
      const item = { id: created.id, label: values.name, subtitle: values.gstNumber || values.phone };
      message.success(`Party "${item.label}" created`);
      onCreated(item);
      form.resetFields();
    } catch (err) {
      message.error(getApiErrorMessage(err, "Unable to create party"));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      rootClassName="static-overlay-modal"
      title="Add New Party"
      open={open}
      onCancel={onClose}
      afterOpenChange={handleAfterOpen}
      destroyOnClose
      width={760}
      footer={
        <Space style={{ justifyContent: "flex-end", width: "100%" }}>
          <Button onClick={onClose}>Cancel</Button>
          <Button type="primary" loading={saving} onClick={() => void handleSave()}>
            Save Party
          </Button>
        </Space>
      }
    >
      <Form form={form} layout="vertical" className="party-composite-form" style={{ marginTop: 8 }}>
        <PartyCompositeFormFields form={form} editing={false} />
      </Form>
    </Modal>
  );
};
